// db.js
import { collection, addDoc, getDocs, query, where, updateDoc, doc, deleteDoc } from "firebase/firestore";
import { db } from "./firebase";

// Add a new appointment
export const addAppointment = async (data) => {
  await addDoc(collection(db, "appointments"), data);
};

// Get all appointments
export const getAppointments = async () => {
  const snapshot = await getDocs(collection(db, "appointments"));
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// Update an appointment
export const updateAppointment = async (id, data) => {
  const docRef = doc(db, "appointments", id);
  await updateDoc(docRef, data);
};

// Delete an appointment
export const deleteAppointment = async (id) => {
  const docRef = doc(db, "appointments", id);
  await deleteDoc(docRef);
};
